import './traffic-light.css';

export const TrafficLightColor = ({ value, color }) => {
  return (
    <div className={`light-container-${color} ${value ? 'active': null}`}>
        <div className={`light-item-${color} ${value ? 'active': null}`}></div>
    </div>
  );
}
